import {
    PROCESSED_SUBSCRIBER, SUBMIT_FORM, STOP_SUBMIT_FORM, SUBMIT_SMS_FORM, SET_SUBSCRIPTION_EMAIL
} from '../actions/users';

const INITIAL_STATE = {
    isLoading: false
};

function UsersReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
        case SUBMIT_SMS_FORM:
            return { ...state, isLoading: true };
        case SUBMIT_FORM:
            return { ...state, isLoading: true };
        case STOP_SUBMIT_FORM:
            return { ...state, isLoading: false};
        case PROCESSED_SUBSCRIBER:
            return { ...state, isLoading: true };
        case SET_SUBSCRIPTION_EMAIL:
            return { ...state, isLoading: true };
        default:
            return state;
    }
}

export default UsersReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/reducer_users.js
 **/